import {
    getFilters,
    getSortName,
    getSortOrder
} from '../../components/helpers/helpers';
import {
    ROOT_URL
} from '../../config';
import request from '../../components/api/api';
import {
    fetchingItems,
    fetchedItems,
    setItemsGridCurrentPage,
    setItemsGridFilterCriteria,
    setItemsGridRecordsPerPage,
    setItemsGridSortCriteria
} from './actions';

export function fetchItemsChunks(gridId, url, currentPage, perPage, sorted, filtered, callbackFetchedItems) {

    let sortName = getSortName(sorted);
    let sortOrder = getSortOrder(sorted);
    let filters = getFilters(filtered);

    return dispatch => {

        dispatch(fetchingItems(gridId));
        dispatch(setItemsGridCurrentPage(gridId, currentPage));
        dispatch(setItemsGridRecordsPerPage(gridId, perPage));
        dispatch(setItemsGridSortCriteria(gridId, sorted));
        dispatch(setItemsGridFilterCriteria(gridId, filtered));

        let options = {
            url: `${ROOT_URL}${url}?_page=${currentPage + 1}&_limit=${perPage}&_sort=${sortName}&_order=${sortOrder}${filters}`,
            method: 'GET'
        };

        return request(options, dispatch)
            .then(response => {
                let totalRecords = response.headers['x-total-count'];
                    let totalPages = Math.ceil(totalRecords / perPage);
                    callbackFetchedItems(response.data, totalPages);
                    dispatch(fetchedItems(gridId, response.data, totalPages));
            })
    };
}


// WEBPACK FOOTER //
// ./src/containers/grid/thunks.js